import { Helmet } from "react-helmet-async";

/**
 * Restaurant JSON-LD structured data for Google Rich Results.
 * Include this once on the Home page (site-wide entity). Optional page-specific
 * schema (Menu, Event) can be added later per page.
 */
const RESTAURANT_LD = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  "@id": "https://thebarracksbistro.in/#restaurant",
  name: "The Barracks Bistro",
  url: "https://thebarracksbistro.in/",
  image: [
    "https://thebarracksbistro.in/images/hero.jpg",
    "https://thebarracksbistro.in/images/dining.jpg",
    "https://thebarracksbistro.in/images/events-1.jpg",
  ],
  telephone: "+91-82204-10761",
  email: "tbb@sigacoffee.com",
  priceRange: "₹₹",
  servesCuisine: ["Indian", "Continental", "Chinese", "Grill"],
  acceptsReservations: "https://thebarracksbistro.in/reservations",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Madras Regimental Centre",
    addressLocality: "Wellington",
    addressRegion: "The Nilgiris, Tamil Nadu",
    addressCountry: "IN",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 11.363,
    longitude: 76.783,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Sunday"],
      opens: "11:30",
      closes: "22:30",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Friday", "Saturday"],
      opens: "11:30",
      closes: "23:30",
    },
  ],
  hasMenu: "https://thebarracksbistro.in/menu",
  sameAs: [],
  amenityFeature: [
    { "@type": "LocationFeatureSpecification", name: "Lakeside seating", value: true },
    { "@type": "LocationFeatureSpecification", name: "Bonfire nights", value: true },
    { "@type": "LocationFeatureSpecification", name: "Private events", value: true },
    { "@type": "LocationFeatureSpecification", name: "Wedding hosting", value: true },
  ],
};

export default function RestaurantSchema() {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(RESTAURANT_LD)}
      </script>
    </Helmet>
  );
}
